// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store'
import Vuetify from 'vuetify'
import 'moment/locale/ru'
import moment from 'moment'
import underscore from 'vue-underscore'
import VueLocalStorage from 'vue-localstorage'
import VueFormGenerator from 'vue-form-generator'
import VueUploadComponent from 'vue-upload-component'
import interceptors from './axios'
import YmapPlugin from 'vue-yandex-maps'

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vuetify/dist/vuetify.min.css'
import 'vue-form-generator/dist/vfg.css'
import config from './config'

Vue.config.productionTip = false
Vue.component('Date', Date)
Vue.component('file-upload', VueUploadComponent)
Vue.use(Vuetify, {
  theme: {
    primary: '#007BFF',
    success: '#5AB300'
  }
})
Vue.use(VueLocalStorage)
Vue.use(underscore)
Vue.prototype.moment = moment
Vue.use(VueFormGenerator)
Vue.use(YmapPlugin, config.yandexApiSettings)

interceptors()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js